import { render } from "./VideoConsultation.vue?vue&type=template&id=5e3c3f9e&scoped=true"
import script from "./VideoConsultation.vue?vue&type=script&lang=js"
export * from "./VideoConsultation.vue?vue&type=script&lang=js"

import "./VideoConsultation.vue?vue&type=style&index=0&id=5e3c3f9e&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3c3f9e"]])

export default __exports__